export interface ArticleCard {
  title: string;
  slug: string;
  excerpt: string;
  readTime: string;
  category: string;
  imageQuery: string;
  isFeature?: boolean;
}

export const articleCards: ArticleCard[] = [
  {
    title: "The Complete Hipobuy Spreadsheet Guide for Smart Shoppers",
    slug: "hipobuy-spreadsheet-complete-guide",
    excerpt: "Everything you need to know about using Hipobuy Spreadsheet to discover products, compare options, and make smarter purchasing decisions with organized data.",
    readTime: "12 min read",
    category: "Guides",
    imageQuery: "Modern minimalist workspace with laptop showing organized spreadsheet product data, clean aesthetic, soft natural morning light, editorial photography with warm neutral tones, coffee cup on wooden desk",
    isFeature: true
  },
  {
    title: "Hipobuy vs Kakobuy Spreadsheet: Complete 2026 Comparison",
    excerpt: "Detailed side-by-side comparison of Hipobuy Spreadsheet and Kakobuy Spreadsheet — category coverage, update frequency, ease of use, and which platform fits your needs.",
    readTime: "10 min read",
    category: "Comparison",
    imageQuery: "Two modern laptops side by side on minimal wooden desk showing different spreadsheet interfaces, split screen comparison concept, warm natural lighting, editorial photography, clean professional aesthetic",
    slug: "hipobuy-vs-kakobuy-spreadsheet",
    isFeature: false
  },
  {
    title: "Hipobuy vs CSSBuy Spreadsheet: Features & User Experience Compared",
    excerpt: "In-depth comparison between Hipobuy Spreadsheet and CSSBuy Spreadsheet — discover which platform better serves your product discovery and logistics research needs.",
    readTime: "9 min read",
    category: "Comparison",
    imageQuery: "Two tablets on minimal desk displaying spreadsheet comparison charts, clean modern workspace, warm ambient lighting, editorial photography with soft shadows, professional tech aesthetic",
    slug: "hipobuy-vs-cssbuy-spreadsheet",
    isFeature: false
  },
  {
    title: "Hipobuy vs Superbuy Spreadsheet: Ultimate Platform Showdown",
    excerpt: "Premium vs comprehensive — compare Hipobuy Spreadsheet and Superbuy Spreadsheet across categories, curation quality, community features, and update frequency.",
    readTime: "11 min read",
    category: "Comparison",
    imageQuery: "Premium minimalist workspace with two screens showing spreadsheet data side by side, luxurious desk setup, warm golden hour lighting, editorial photography, high end professional aesthetic",
    slug: "hipobuy-vs-superbuy-spreadsheet",
    isFeature: false
  },
  {
    title: "Hipobuy vs Oopbuy Spreadsheet: Niche Alternative Comparison",
    excerpt: "Explore how Oopbuy Spreadsheet differs from Hipobuy — the alternative perspective on product discovery, curation philosophy, and community experience for curious shoppers.",
    readTime: "9 min read",
    category: "Comparison",
    imageQuery: "Minimal desk setup with laptop and tablet showing alternative spreadsheet views, clean aesthetic, soft morning light through window, editorial photography, calm workspace atmosphere",
    slug: "hipobuy-vs-oopbuy-spreadsheet",
    isFeature: false
  },
  {
    title: "How to Find the Best Products Using Spreadsheet Databases",
    excerpt: "Learn proven strategies for navigating spreadsheet product databases to uncover trending items and hidden gems before everyone else.",
    readTime: "6 min read",
    category: "Tips",
    imageQuery: "Person browsing organized product catalog on clean modern interface, soft natural lighting, editorial style with warm minimal aesthetic",
    slug: "best-products-spreadsheet-database",
    isFeature: false
  },
  {
    title: "Safety Tips for Shopping Through Spreadsheet Resources",
    excerpt: "Essential safety guidelines every shopper should know before using spreadsheet-based product discovery platforms and making purchases.",
    readTime: "5 min read",
    category: "Safety",
    imageQuery: "Security shield concept on minimal clean background, modern editorial photography, soft warm lighting, trust and safety aesthetic",
    slug: "safety-tips-spreadsheet-shopping",
    isFeature: false
  },
  {
    title: "Trending Product Categories to Watch This Season",
    excerpt: "Stay ahead of the curve with our curated overview of the hottest product categories making waves in spreadsheet shopping communities.",
    readTime: "5 min read",
    category: "Trends",
    imageQuery: "Trending fashion items collection on minimal clean background, modern editorial photography, soft natural lighting, lifestyle aesthetic",
    slug: "trending-product-categories",
    isFeature: false
  }
];